export var FlowRunState;
(function (FlowRunState) {
    FlowRunState["Pending"] = "Pending";
    FlowRunState["PendingRetry"] = "PendingRetry";
    FlowRunState["Queued"] = "Queued";
    FlowRunState["Running"] = "Running";
    FlowRunState["Completed"] = "Completed";
    FlowRunState["Failed"] = "Failed";
    FlowRunState["Canceled"] = "Canceled";
})(FlowRunState || (FlowRunState = {}));
/** States a run can still be cancelled from. */
export const CANCELLABLE_FLOW_RUN_STATES = [
    FlowRunState.Pending,
    FlowRunState.PendingRetry,
    FlowRunState.Queued,
    FlowRunState.Running,
];
/** States a run can be picked up from and started. */
export const QUEUEABLE_FLOW_RUN_STATES = [
    FlowRunState.Pending,
    FlowRunState.PendingRetry,
];
/** States a run never leaves. */
export const TERMINAL_FLOW_RUN_STATES = [
    FlowRunState.Completed,
    FlowRunState.Failed,
    FlowRunState.Canceled,
];
export function isCancellableFlowRunState(state) {
    return CANCELLABLE_FLOW_RUN_STATES.includes(state);
}
export function isQueueableFlowRunState(state) {
    // If we ever want workflows to be re-entrant (resume an already started workflow) we might include states like Running here.
    return QUEUEABLE_FLOW_RUN_STATES.includes(state);
}
export function isTerminalFlowRunState(state) {
    return TERMINAL_FLOW_RUN_STATES.includes(state);
}
//# sourceMappingURL=flowRunState.js.map